export function formatDateTime(val, hasTime = false) {
  if (val) {
    let date = new Date(`${val}`);
    date = new Date(date.toString().replace("Standard", "Daylight"));
    let time = date.toLocaleTimeString(navigator.language, {
      hour: "2-digit",
      minute: "2-digit"
    });
    let dateString = date.toLocaleDateString("en-GB");

    return hasTime ? `${dateString} ${time}` : dateString;
  }
}

export function formatStatus(status) {
  let statusArray = {
    0: "<span style='color: #383d41;'>Cancelled</span>",
    1: "<span style='color: #f44336;'>Rejected</span>",
    2: "<span style='color: #0c5460;'>Pending</span>",
    3: "<span style='color: #f58634;'>In Progress</span>",
    4: "<span style='color: #4caf50;'>Completed</span>",
    5: "<span style='color: #004085;'>Signed</span>",
    6: "<span style='color: #383d41;'>Unknown</span>"
  };

  return `<b>${statusArray[status]}</b>`;
}
